export default "__VITE_ASSET__9e32830f__"